import { EditAliasPayload } from '@repo/accounts-types'
import { GenericOperationState } from '@repo/core'
import { RootState } from '../../../store/types'

export const editAliasDataSelectorConfig = {
  editAliasDataSelector: {
    getRootPath: function (state: RootState): GenericOperationState<EditAliasPayload> {
      return state.accounts.detail.write.editAlias.data
    },
  },
}
